import React, { createContext, useContext, useState } from "react";
import { ISidebarContext } from "../exports/interfaces";

const SidebarContext = createContext<ISidebarContext>({
  sidebarOpen: false,
  setSidebarOpen: () => null,
});
export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};
